import SimpleInterpolator from '@spa/lib/i18n/common/SimpleInterpolator';
import { TranslationsById } from '@spa/lib/i18n/common/TranslationsById';
import logger from '@spa/lib/logger';

const interpolator = new SimpleInterpolator();

const formatMessage = (
  enableWarnings: boolean,
  translationsById: TranslationsById,
  id: string,
  namespace: string,
  values?: Record<string, string | number | null | undefined>,
  fallbackValue?: string,
  fallbackIds?: ReadonlyArray<string>
): string => {
  let i18nRawValue = translationsById[id];
  if (i18nRawValue === undefined) {
    if (fallbackIds !== undefined) {
      for (const fallbackId in fallbackIds) {
        i18nRawValue = translationsById[fallbackId];
        if (i18nRawValue !== undefined) {
          break;
        }
      }
    }

    if (i18nRawValue === undefined) {
      i18nRawValue = fallbackValue;
    }
  }

  let message: string;
  if (i18nRawValue === undefined) {
    message = id;
    if (enableWarnings) {
      logger.warn(`Missing translation [Id: ${id}, Namespace: ${namespace}]`);
    }
  } else if (values === undefined) {
    message = i18nRawValue;
  } else {
    message = interpolator.replace(i18nRawValue, values);
  }

  return message;
};

export default formatMessage;
